import React from 'react'
import Menu from '../component/Menu';
import HeaderCasestudy from '../component/HeaderCasestudy';
import Casestudybody from '../component/Casestudybody27';
import FooterNew from '../component/FooterNew';
import { Helmet } from 'react-helmet';

const CaseStudy27 = ({setBlank}) => {
     
    const headings = "<h2 style='display:inline-block;color:#ffffff;'> Annual Operating Plan and Budget </h2><h4>for a Single Family Office</h4>";

  return (
    <>
        <Helmet>
        <title>Annual Operating Plan and Budget for a Single Family Office</title>
        <meta property="og:title" content="Annual Operating Plan and Budget for a Single Family Office" />
        <meta property='og:description' content='Annual Operating Plan and Budget for a Single Family Office'/>
        <meta name='keywords' content=''/>
        </Helmet>

        <Menu setBlank={setBlank}  />
        <HeaderCasestudy class="header-casestudy27" headings={headings} />  
        <Casestudybody />
        <FooterNew setBlank={setBlank} />
    </>
  )
}

export default CaseStudy27
